package com.appsyde.shared.modules.ticket.domain.model

enum class Direction { INBOUND, OUTBOUND, UNKNOWN }
